<template>

    <div>
        <h1>PPanel Import</h1>
        <v-select
                id="projectSelector"
                :getOptionLabel="option =>option.name"
                @input="setActiveProject"
                :options="existingStructure.projects"
                :value="selectedProject"
                :disabled="stateMessage==='ready'"
        ></v-select>
       <input type="file" @change="onFileChange">
        <br><br>

        <table style="margin-bottom: 50px;">
            <tr :key="ridx +'-'+ row.started" v-for="(row,ridx) in csvToImport">
                <td style="background: azure">
                    <input v-if="row.canImport" type="checkbox" id="checkbox" v-model="row.doImport" @input="selected => setSelectedRowField(row,'doImport',!row.doImport)">
                    <span style="white-space: nowrap; font-size: 10px" v-if="row.message">{{row.message}}</span>
                </td>
                <td :key="ridx +'-'+ fidx +'-'+ row.started" v-for="(field,fidx) in row.data">
                    {{field}}
                </td>
            </tr>
        </table>

        <div class="buttonbar">
            <pd-button v-if="stateMessage==='ready'" label="Start Import" :click="invokeImport"></pd-button>
        </div>
    </div>

</template>


<script>
    import {mapGetters, mapState} from 'vuex';
    import Button from "@/components/button";


    export default {
        name: 'importConfigs',
        props: {
            msg: String
        },
        components: {
            "pd-button": Button,
        },
        computed: {
            ...mapState("ppanelImportStore", [
                "stateMessage","csvToImport","existingStructure","selectedProject"
            ]),
            ...mapGetters('ppanelImportStore', [
                "stateMessage","csvToImport","existingStructure","selectedProject"
            ])
        },
        methods: {
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    return;
                }
                var reader = new FileReader();
                this.$store.commit('ppanelImportStore/setMessage',"analyze");
                reader.onload = () => {
                    this.$store.commit('ppanelImportStore/setCsv',reader.result);
                    this.$store.commit('ppanelImportStore/setMessage',"ready");
                };
                reader.readAsText(files[0]);
            },
            invokeImport(){
                this.$store.commit('ppanelImportStore/importSelected');
            },
            setActiveProject(project){
                this.$store.commit('ppanelImportStore/setProject',project);
            },

            setSelectedRowField(row,field,value){
                row[field]=value;
            }
        },
        created() {
            this.$store.commit('ppanelImportStore/loadFromDb');
        }
    }
</script>